import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import participantsSlice from "./reducers/participantsSlice";
import userSlice from "./reducers/userSlice";
import administratorsSlice from "./reducers/administratorsSlice";
import questionSlice from "./reducers/questionSlice";
import responseSlice from "./reducers/responseSlice";
import appSlice from "./reducers/appSlice";
import studySlice from "./reducers/studySlice";
import organisationSlice from "./reducers/organisationSlice";
import featuresSlice from "./reducers/featuresSlice";
import questionTranslationSlice from "./reducers/questionTranslationSlice";
import analysisSlice from "./reducers/analysisSlice";
import consentSlice from "./reducers/consentSlice";
import providerConsentSlice from "./reducers/providerConsentSlice";
import participantTabSlice from "./reducers/participantTabSlice";
import appCustomizationSlice from "./reducers/appCustomizationSlice";
import exerciseCollectionSlice from "./reducers/exerciseCollectionSlice";
import messagesSlice from "./reducers/messagesSlice";
import cmsSlice from "./reducers/cmsSlice";
import cmsBuilderSlice from "./reducers/cmsBuilderSlice";
import healthSlice from "./reducers/healthSlice";
import aiSearchSlice from "./reducers/aiSearchSlice";
import cohortSlice from "./reducers/cohortSlice";
import appointmentSlice from "./reducers/appointmentSlice";
import maintenanceSlice from "./reducers/maintenanceSlice";

export const store = configureStore({
  reducer: {
    user: userSlice,
    participants: participantsSlice,
    administrators: administratorsSlice,
    question: questionSlice,
    questionTranslation: questionTranslationSlice,
    response: responseSlice,
    study: studySlice,
    app: appSlice,
    appointment: appointmentSlice,
    organisation: organisationSlice,
    features: featuresSlice,
    analysis: analysisSlice,
    consent: consentSlice,
    providerConsent: providerConsentSlice,
    participantTab: participantTabSlice,
    messages: messagesSlice,
    appCustomization: appCustomizationSlice,
    exerciseCollection: exerciseCollectionSlice,
    cms: cmsSlice,
    cmsBuilder: cmsBuilderSlice,
    health: healthSlice,
    aiSearch: aiSearchSlice,
    cohort: cohortSlice,
    maintenance: maintenanceSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
